import React from "react";
import "./shared.css";

export default function Button({
  children,
  variant = "primary", // primary, secondary, ghost, danger
  size = "md", // sm, md, lg
  onClick,
  disabled,
  type = "button",
  icon: Icon,
  className = "",
  ...props
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`btn-shared btn-${variant} btn-size-${size} ${className}`}
      {...props}
    >
      {Icon && <Icon className="btn-icon" size={size === "sm" ? 14 : 16} />}
      {children}
    </button>
  );
}
